const API_BASE = (
  process.env.REACT_APP_API_URL ||
  "https://api.psyassist.com.br"
).replace(/\/$/, "");

function createApiError(message, status, data) {
  const error = new Error(message);
  error.status = status;
  error.data = data;
  return error;
}

async function parseJsonResponse(response) {
  return response.json().catch(() => ({}));
}

function updateTokenFromResponse(response) {
  const newToken = response.headers.get("x-new-token");

  if (!newToken) {
    return;
  }

  try {
    const sessionToken =
      sessionStorage.getItem("psy_token");

    if (sessionToken) {
      sessionStorage.setItem(
        "psy_token",
        newToken
      );
    } else {
      localStorage.setItem(
        "psy_token",
        newToken
      );
    }
  } catch {
    // Mantém o fluxo.
  }
}

async function requestAgentApi({
  token,
  path,
  method = "GET",
  body,
}) {
  if (!token) {
    throw new Error(
      "Token de autenticação ausente."
    );
  }

  const response = await fetch(
    `${API_BASE}${path}`,
    {
      method,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body:
        body === undefined
          ? undefined
          : JSON.stringify(body),
    }
  );

  const data =
    await parseJsonResponse(response);

  if (!response.ok) {
    throw createApiError(
      data?.message ||
        `Erro na PSYA (HTTP ${response.status}).`,
      response.status,
      data
    );
  }

  updateTokenFromResponse(response);

  return data;
}

export async function sendAgentMessage({
  token,
  message,
  history = [],
  days = 30,
  tz = "America/Sao_Paulo",
  conversaId = null,
} = {}) {
  const normalizedMessage =
    String(message || "").trim();

  if (!normalizedMessage) {
    throw new Error(
      "Digite uma mensagem para a PSYA."
    );
  }

  return requestAgentApi({
    token,
    path: "/psy/agent/chat",
    method: "POST",
    body: {
      message: normalizedMessage,
      history:
        Array.isArray(history)
          ? history.slice(-10)
          : [],
      days,
      tz,
      conversaId,
    },
  });
}

export async function confirmAgentMemory({
  token,
  memoryId,
} = {}) {
  if (!memoryId) {
    throw new Error(
      "ID da memória não informado."
    );
  }

  return requestAgentApi({
    token,
    path: `/psy/agent/memories/${encodeURIComponent(
      memoryId
    )}/confirm`,
    method: "PATCH",
    body: {},
  });
}

export async function confirmAgentMemoryUpdate({
  token,
  memoryId,
  suggestedContent,
  suggestedSummary,
  relevancia,
} = {}) {
  if (!memoryId) {
    throw new Error(
      "ID da memória não informado."
    );
  }

  return requestAgentApi({
    token,
    path: `/psy/agent/memories/${encodeURIComponent(
      memoryId
    )}/confirm-update`,
    method: "PATCH",
    body: {
      conteudo: suggestedContent,
      resumo: suggestedSummary,
      relevancia,
    },
  });
}

export async function deactivateAgentMemory({
  token,
  memoryId,
} = {}) {
  if (!memoryId) {
    throw new Error(
      "ID da memória não informado."
    );
  }

  return requestAgentApi({
    token,
    path: `/psy/agent/memories/${encodeURIComponent(
      memoryId
    )}/deactivate`,
    method: "PATCH",
    body: {},
  });
}
